export default __webpack_public_path__ + "static/media/displays_alternative_description_images.089d5753.svg";